import { Alert, Flex } from 'front-commons/ds';
import useDrawer from 'stores/drawer';
import { ChangeDistributorsButton } from '../../styles';
import { UnavailableAlertProps } from './interfaces';

export function UnavailableAlert({
	promotionId,
	canChangeDistributors,
	onRedirectToDistributors,
}: UnavailableAlertProps) {
	const { handleOpenDrawer } = useDrawer();

	function handleChangeDistributors() {
		if (onRedirectToDistributors) return onRedirectToDistributors();

		handleOpenDrawer('catalog-distributor-change', {
			promotionId,
			showReturnButton: true,
		});
	}

	return (
		<Flex gap="1rem" direction="column">
			<Alert type="warn">Indisponível na sua seleção de distribuidores.</Alert>

			{canChangeDistributors && (
				<ChangeDistributorsButton width="100%" variant="outlined" onClick={handleChangeDistributors}>
					Alterar distribuidores
				</ChangeDistributorsButton>
			)}
		</Flex>
	);
}
